import _                                                                                            from 'underscore';
import React, { CSSProperties, FC, useContext }                                                     from 'react';
import { ColoredClosableHeader, ColoredClosableHeaderProps, StyledContainer, StyledContainerProps } from '../../containers';
import { Position, Size, SystemEvent }                                                              from '../../../types';
import { CorvalStylizedHexContainer, HexContainerPreset }                                           from '../product/CorvalStylizedHexContainer';
import { DynamicComponentsContext }                                                                 from '../../contexts';
import { TogglableContentHook }                                                                     from '../../../hooks/useTogglableContentReducer';
import { ModalProps }                                                                               from 'semantic-ui-react';


export interface BasicDialogContainerProps {

    /* Does this modal operate inside the system, or is it used in layout outside of contexts? */
    hasSystemContext?: boolean,

    /* Title of the dialog */
    title?: string,

    /* Support title color */
    titleColor?: ColoredClosableHeaderProps['color'],

    /* Round off the top edges of modal? */
    roundedTop?: boolean,

    /* Should the container scroll? */
    scrolling?: boolean,

    /* Should the container show or hide content that overflows */
    overflow?: boolean,

    /* Specifies a set height for content container */
    contentHeight?: string | number | 'auto',
    contentMinHeight?: string | number,
    contentMaxHeight?: string | number,

    /* Specifies a padding for content container */
    contentPadding?: StyledContainerProps['padding'],

    /* The onClose handler for the modal; Pass false to not have it present */
    onClose?: ( { ( e: SystemEvent ): void } | boolean ),

    containerStyles?: CSSProperties,

    [ additionalProps: string ]: any
}

const defaultProps: BasicDialogContainerProps = {
    hasSystemContext: true,
    title:            null,
    onClose:          null,
    scrolling:        false,
    overflow:         false,
    roundedTop:       true,
    contentHeight:    'auto',
    contentMinHeight: null,
    contentMaxHeight: null,
    contentPadding:   Size.LG,
    containerStyles:  {},
}

const BasicDialogContainer: FC<BasicDialogContainerProps> = ( props ) => {

    let { modal: [ , modalActions ] } = props.hasSystemContext ? useContext( DynamicComponentsContext ) : { modal: [ {}, {} ] as TogglableContentHook<ModalProps> };

    let handleOnClose = ( e: SystemEvent ): void => {

        if( _.isFunction( props.onClose ) ){

            props.onClose( e );

        } else if( props.hasSystemContext ){

            modalActions.toggle( false );
        }
    }

    let headerStyles = ( props.roundedTop ) ? {
        borderTopLeftRadius:  '0.2857rem',
        borderTopRightRadius: '0.2857rem',
        overflow:             'hidden',
    } : {};

    return (

        <>

            { ( props.title || props.onClose ) && (
                <StyledContainer position={ props.scrolling ? Position.STICKY : Position.RELATIVE } top zIndex={ 200 } style={ headerStyles }>
                    <ColoredClosableHeader color={ props.titleColor } title={ props.title } onClose={ ( props.onClose !== false ) ? handleOnClose : null }/>
                </StyledContainer>
            ) }

            <StyledContainer position={ Position.RELATIVE } padding={ props.contentPadding } zIndex={ 100 } style={ {
                height:    props.contentHeight,
                minHeight: props.contentMinHeight,
                maxHeight: props.contentMaxHeight,
                overflowY: props.overflow ? props.scrolling ? 'auto' : 'visible' : 'hidden',
            } }>

                <CorvalStylizedHexContainer inverted fill={ 'area' } zIndex={ 0 } preset={ HexContainerPreset.WHITE }/>

                <StyledContainer zIndex={ 100 } position={ Position.RELATIVE } style={ props.containerStyles }>

                    { props.children }

                </StyledContainer>

            </StyledContainer>

        </>
    );
};

BasicDialogContainer.defaultProps = defaultProps;

export { BasicDialogContainer }
